/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pll_Detail_Col_SourceInputs */

const vi_pll_detail_col_source = /** @type {(inputs: Pll_Detail_Col_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lô lấy hương nguồn`)
};

/**

* @param {Pll_Detail_Col_SourceInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pll_detail_col_source = /** @type {((inputs?: Pll_Detail_Col_SourceInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pll_Detail_Col_SourceInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pll_detail_col_source(inputs)
});